export default __webpack_public_path__ + "static/media/logo-white.4672cca6.png";